import React from 'react';
import './Clients.css';
import imageLeft from '../assets/image_left.png';
import AngularIcon from '../assets/angular-image.svg';
import AWSIcon from '../assets/aws-image.svg';
import FirebaseIcon from '../assets/firebase-image.svg';
import FlutterIcon from '../assets/flutter-image.svg';
import GoogleCloudIcon from '../assets/google-cloud-image.svg';
import MongoDBIcon from '../assets/mongodb-image.svg';
import PythonIcon from '../assets/python-image.svg';
import ReactIcon from '../assets/react-image.svg';

const Team: React.FC = () => {
  const teamValues = [
    {
      title: 'Metodología Ágil',
      description: 'Trabajamos con sprints cortos y entregas continuas para garantizar resultados rápidos y adaptabilidad.',
      icon: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#78f9fb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
      </svg>
    },
    {
      title: 'Comunicación Transparente',
      description: 'Mantenemos comunicación constante con nuestros clientes, reportes semanales y acceso al progreso en tiempo real.',
      icon: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#78f9fb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      </svg>
    },
    {
      title: 'Calidad Garantizada',
      description: 'Cada línea de código pasa por revisiones rigurosas y pruebas automatizadas antes de llegar a producción.',
      icon: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#78f9fb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 12l2 2 4-4"/>
        <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c.395 0 .785.025 1.166.072"/>
      </svg>
    }
  ];

  const technologies = [
    { name: 'React', icon: ReactIcon },
    { name: 'Angular', icon: AngularIcon },
    { name: 'Flutter', icon: FlutterIcon },
    { name: 'Python', icon: PythonIcon },
    { name: 'AWS', icon: AWSIcon },
    { name: 'Google Cloud', icon: GoogleCloudIcon },
    { name: 'Firebase', icon: FirebaseIcon },
    { name: 'MongoDB', icon: MongoDBIcon }
  ];

  return (
    <section id="equipo" className="team">
      <div className="container">
        <h2 className="section-title">Nuestro Equipo</h2>
        <p className="section-subtitle">
          Somos un equipo especializado en automatización empresarial, comprometidos con la excelencia y la innovación constante.
        </p>
        
        <div className="team-intro">
          <div className="team-grid">
            <div className="team-image-container">
              <img src={imageLeft} alt="Nuestro Equipo" className="team-image" />
            </div>
            <div className="team-description">
              <h3>Cómo Trabajamos</h3>
              <p>
                En TERA creemos que el mejor software nace de la colaboración estrecha con nuestros clientes. 
                Nuestro equipo multidisciplinario combina experiencia técnica con visión estratégica para 
                entregar soluciones que realmente transformen tu negocio.
              </p>
              <p>
                Desde el primer contacto hasta la implementación final, trabajamos contigo paso a paso, 
                asegurándonos de que cada solución esté perfectamente alineada con tus objetivos empresariales.
              </p>
            </div>
          </div>
        </div>

        <div className="team-methodology">
          <h3>Nuestra Metodología</h3>
          <div className="methodology-grid">
            {teamValues.map((value, index) => (
              <div key={index} className="methodology-card">
                <div className="methodology-icon">{value.icon}</div>
                <h4>{value.title}</h4>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="team-technologies">
          <h3>Tecnologías que Dominamos</h3>
          <div className="tech-grid">
            {technologies.map((tech, index) => (
              <div key={index} className="tech-item">
                <img src={tech.icon} alt={tech.name} />
                <span>{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;